<app-store-payment-tip
    [customTipData] = "paymentData"
    [selectedTipValue]="getSelectedTipValue()"
    (tipChange)="onTipChange($event)">
</app-store-payment-tip>